import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import useApiUpgradeModal from 'Hooks/Common/useApiUpgradeModal';
import useUpgradeModal from 'Hooks/Common/useUpgradeModal';
import { PlanTypes } from 'Interfaces/Billing';
import { DocumentStatuses } from 'Interfaces/Document';
import { AuthorizedRoutePaths } from 'Interfaces/RoutePaths';
import { User } from 'Interfaces/User';
import {
  selectApiPlan,
  selectApiTemplatesCount,
  selectCommonTemplatesCount,
  selectUser,
  selectUserPlan,
} from 'Utils/selectors';

export default (type?: DocumentStatuses) => {
  const navigate = useNavigate();
  const userPlan = useSelector(selectUserPlan);
  const user = useSelector(selectUser) as User;
  const apiPlan = useSelector(selectApiPlan);
  const apiTemplatesCount = useSelector(selectApiTemplatesCount);
  const commonTemplatesCount = useSelector(selectCommonTemplatesCount);

  const [openUpgradeModal] = useUpgradeModal();
  const [openApiUpgradeModal] = useApiUpgradeModal();

  const navigateToCreateTemplate = useCallback(() => {
    if (type === DocumentStatuses.ACTIVE) {
      if (
        !user.teamId &&
        (userPlan.type === PlanTypes.FREE ||
          (userPlan.type === PlanTypes.PERSONAL && commonTemplatesCount >= 1))
      ) {
        openUpgradeModal();
      } else {
        navigate(AuthorizedRoutePaths.TEMPLATES_CREATE);
      }
    } else {
      if (apiTemplatesCount >= apiPlan.templateLimit && apiPlan.templateLimit !== -1) {
        openApiUpgradeModal();
      } else {
        navigate(`${AuthorizedRoutePaths.TEMPLATES_CREATE}?status=api`);
      }
    }
  }, [
    apiPlan.templateLimit,
    apiTemplatesCount,
    commonTemplatesCount,
    navigate,
    openApiUpgradeModal,
    openUpgradeModal,
    type,
    user.teamId,
    userPlan.type,
  ]);

  return [navigateToCreateTemplate];
};
